import GradientContainer from "@app/components/gradient/gradient-container";
import Image from "next/image";

const EquippedSectionTopContent = () => {
  return (
    <div className="grid grid-cols-12 w-full gap-y-8 md:gap-x-4 lg:gap-x-16">
      <div className="col-span-12 md:col-span-6">
        <div className="flex justify-center md:justify-end items-center h-full">
          <Image
            src="/images/haulers/equipped-01.png"
            alt="Equipped"
            width={550}
            height={579}
          />
        </div>
      </div>
      <div className="col-span-12 md:col-span-6 flex flex-row items-center">
        <div className="md:w-[560px] flex flex-col items-start space-y-4">
          <span className="mobile-h3 md:h4 lg:h3 text-text-color-high-em">
            Exclusive Technology
          </span>
          <GradientContainer>
            <div className="h-2 w-40" />
          </GradientContainer>
          <span className="text-body-lg text-text-color-mid-em">
            The SimpleWaste technology platform provides a vendor-facing
            interface designed to connect service with opportunity. Set bidding
            preferences to fit your service areas and waste profiles.
          </span>
        </div>
      </div>
    </div>
  );
};

export default EquippedSectionTopContent;
